export default __webpack_public_path__ + "static/media/igiv-screenshot-leaderboard.6bfd6498.png";